"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _RecurringCreditsModal = _interopRequireDefault(require("../components/RecurringCreditsModal"));

var _api = require("../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function RecurringCreditsModalContainer(_ref) {
  var organisationId = _ref.organisationId,
      isVisible = _ref.isVisible,
      selectedTeam = _ref.selectedTeam,
      onClose = _ref.onClose,
      onSave = _ref.onSave,
      orgRecurringBalance = _ref.orgRecurringBalance,
      isUnlimited = _ref.isUnlimited;
  return /*#__PURE__*/_react.default.createElement(_commonReact.RequestProvider, {
    requests: {
      createTeamCreditRule: (0, _api.createTeamCreditRuleMutation)(organisationId),
      updateCreditRule: (0, _api.updateCreditRuleMutation)(organisationId)
    }
  }, function (_ref2) {
    var createTeamCreditRule = _ref2.createTeamCreditRule,
        updateCreditRule = _ref2.updateCreditRule;
    return /*#__PURE__*/_react.default.createElement(_RecurringCreditsModal.default, {
      isVisible: isVisible,
      selectedTeam: selectedTeam,
      isUnlimited: isUnlimited,
      onClose: onClose,
      onSave: onSave,
      orgRecurringBalance: orgRecurringBalance,
      createTeamCreditRule: createTeamCreditRule,
      updateCreditRule: updateCreditRule
    });
  });
}

var _default = RecurringCreditsModalContainer;
exports.default = _default;